<div [id]="modalable?.getModalId()" aria-hidden="true" class="modal" role="dialog" tabindex="-1">
    <div [class.link-overlay]="modalable?.overlay" class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">

                @if (!modalable?.overlay) {
                    @if (modalable?.content) {
                        <p class="link-content">{{ modalable?.content }}</p>
                    }
                    <button class="close-button" data-bs-dismiss="modal" type="button">
                        <i aria-hidden="true" class="fa fa-times"></i>
                    </button>
                    <a (click)="onClick()" [attr.href]="modalable.url" [class.extra-margin]="!modalable?.content"
                       appDigi4SchoolValidation target="_blank">
                        <img [src]="imageUrl" alt="link-logo"/>
                    </a>
                    <a (click)="onClick()" [attr.href]="modalable.url" appDigi4SchoolValidation class="external-link"
                       target="_blank">
                        {{ linkText }}
                    </a>
                    @if (!isTrustedPlatformLink) {
                        <p class="no-accountability">
                            Dieser Link führt zu nicht approbierten Inhalten.
                        </p>
                    }
                }
                @if (modalable?.overlay && iFrameURL && modalable.wasClicked) {
                    <iframe (window:resize)="debouncedOnResize($event)" [attr.src]="iFrameURL" [height]="iFrameHeight"
                            [width]="iFrameWidth"></iframe>
                }

            </div>
            <div class="modal-footer">
                <button data-bs-dismiss="modal">zurück zum Buch</button>
            </div>
        </div>
    </div>
</div>
